import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import useLangTranslation from "../../../customHooks/languageProvider";
import CommonStatus from "../Common/CommonStatus";
import useDeviceStatus from "../../../customHooks/deviceStatusProvider";
import KidImage from "../../../shared/KidImage/KidImage";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import { kidDevices, setKidDevicesList } from "../../AxiosRtk/DashBoard";
import {
  setRuleDataSetUp,
  setupWizardSetup,
  setActiveTab,
  setSetupWizardDeviceId,
} from "../../AxiosRtk/SetRules";
import useFirebase from "../../../../useFirebase";
import { isEmpty } from "lodash";
import {
  setShowMessage,
  setCallFunOnGotIt,
  setErrorInfo,
} from "../../AxiosRtk/successMessage";
import useBatteryPercentage from "../../../customHooks/batteryPercentageProvider";
import { useDashboardDataProvider } from "../../../customHooks/dashboardDataProvider";

const SetupWizard = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [kid, setKid] = useState(null);
  const [deviceId, setDeviceId] = useState("");
  const [deviceOptions, setDeviceOptions] = useState([]);
  const [loader, setLoader] = useState(false);
  const [saveFlag, setSaveFlag] = useState(false);
  const { kidList, selectedKidId, kidDevicesList } = useSelector(
    ({ dashboard }) => dashboard
  );
  const [defaultSettings, setDefaultSetting] = useState({});
  const { setRulesData } = useSelector(({ setRules }) => setRules);
  const { getLangTranslation } = useLangTranslation();
  const [batteryPercentage, setBatteryPercentage] = useState(0);
  const [deviceStatus, setDeviceStatus] = useState("");
  const { handleDeviceSelection } = useDashboardDataProvider();
  const [setupWizardData, setSetupWizardData] = useState(null);
  const { getDeviceStatusData } = useDeviceStatus(
    deviceStatus,
    setDeviceStatus
  );
  const {
    getCollectionData,
    // postCollectionData,
    // createCollectionData,
    callFirebase,
    getDefaultSettingData,
  } = useFirebase();

  const { getBatteryPercentageData } =
    useBatteryPercentage(setBatteryPercentage);


  useEffect(() => {
    if (kidList?.length > 0 && selectedKidId) {
      const kid = kidList?.find((item) => item?.ID === selectedKidId);
      setKid(kid);
    }
  }, []);

  useEffect(() => {
    if (deviceId) {
      getDeviceStatusData(deviceId);
      getCollectionData(deviceId);
      getBatteryPercentageData(deviceId);
    } else {
      setDeviceStatus("");
      dispatch(setRuleDataSetUp(null));
      setSetupWizardData(null);
    }
  }, [deviceId]);

  useEffect(() => {
    setDeviceOptions(
      kidDevicesList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [kidDevicesList]);

  useEffect(() => {
    if (!isEmpty(setRulesData) && !saveFlag) {
      // alert(1, saveFlag);
      setSetupWizardData({ ...setRulesData?.setupWizard });
    } else {
      // alert(2);
      setSetupWizardData(null);
    }
  }, [setRulesData]);

  function handleToggleChange(e) {
    const { name, checked } = e.target;
    if (name === "ALLOW_MONITOR") {
      setSetupWizardData({
        allowAllAndMonitorOnly: checked,
        enableDefaultSettings: false,
        customSettings: false,
      });
    } else if (name === "ENABLE_DEFAULT_SETTINGS") {
      setSetupWizardData({
        allowAllAndMonitorOnly: false,
        enableDefaultSettings: checked,
        customSettings: false,
      });
    } else if (name === "CUSTOM_SETTINGS") {
      const collectionPayload = {
        setupWizard: {
          allowAllAndMonitorOnly: false,
          enableDefaultSettings: false,
          customSettings: checked,
        },
      };
      // callFirebase(deviceId, collectionPayload);
      callServiceFirebaseAndDB(collectionPayload);
    }
  }

  function moveToSetRules() {
    history.push("/set-rules");
    dispatch(setActiveTab("SETRULE_SCREENSHOTS"));
  }

  function moveToDashboard() {
    history.push("/dashboard");
  }

  function callServiceFirebaseAndDB(collectionPayload) {
    dispatch(setSetupWizardDeviceId(deviceId));
    callFirebase(deviceId, collectionPayload);

    let type = 0;

    if (setupWizardData?.allowAllAndMonitorOnly) {
      type = 1;
    } else if (setupWizardData?.enableDefaultSettings) {
      type = 2;
    } else {
      type = 3;
    }

    setupWizardSetup({ deviceId, type })
      .then((res) => {
        dispatch(
          setShowMessage({
            showMessage: true,
            message: "DATA_FETCH",
            defaultMessage: "Data updated successfully",
          })
        );
        setSaveFlag(false);

        if (type === 1 || type === 2) {
          dispatch(setCallFunOnGotIt(moveToDashboard));
        } else if (type === 3) {
          dispatch(setCallFunOnGotIt(moveToSetRules));
        }
      })
      .catch((err) => {
        console.log(
          "setup wizard data update catch error ==>>",
          err?.response?.data?.message
        );
      })
      .finally(() => {
        setLoader(false);
      });
  }

  function adjustDasyOfSchedule(schedule) {
    schedule = schedule?.map((item) => {
      item.day = item?.day?.toLowerCase()
      return item;
    })

    return schedule;
  }

  function handleClick() {
    let collectionPayload = null;
    setSaveFlag(true);

    if (setupWizardData?.allowAllAndMonitorOnly) {
      collectionPayload = {
        ...setRulesData,
        enableSupervision: true,
        setupWizard: { ...setupWizardData },
        webmonitoring: {
          ...setRulesData?.webmonitoring,
          webMonitoringEnabled: true,
          webSupervisionType: 0,
        },
        appsmonitoring: {
          ...setRulesData?.appsmonitoring,
          appMonitoringEnabled: true,
        },
        videomonitoring: {
          ...setRulesData?.videomonitoring,
          videoMonitoringEnabled: true,
        },
        callAndSmsMonitoring: {
          ...setRulesData?.callAndSmsMonitoring,
          callSmsActivate: 1,
        },
        nudityimagecategorization: {
          ...setRulesData?.nudityimagecategorization,
          blockSourceNudityEnable: 1,
          deleteNudePicEnable: 1,
          detectAllNudityEnable: 1,
          onlyNudityEnable: 1,
          screenshotNudityEnable: 1,
        },
        keystrokesmonitoring: {
          keystrokesdata: {
            ...setRulesData?.keystrokesmonitoring?.keystrokesdata,
            activate: 1,
          },
        },
        screenshotsSettings: {
          ...setRulesData?.screenshotsSettings,
          screenshot_settings_enabled: 1,
        },
        setRulesActiveInActiveStatus: {
          ...setRulesData?.setRulesActiveInActiveStatus,
          appMonitoringEnabled: true,
          callsAndSMSMonitoringEnabled: true,
          keysrtrokesMonitoringEnabled: true,
          nudityAndImageCategorizationEnabled: true,
          screenshotsEnabled: true,
          videoMonitoringEnabled: true,
          webMonitoringEnabled: true,
          locationAndGeofencingEnable: true,
        },
        locationgeofendingsettings: {
          geoLocationEnable: defaultSettings.geoLocationEnable,
        },
      };
    }

    if (setupWizardData?.enableDefaultSettings) {
      const keyValuePairs = {
        enableSupervision: defaultSettings.enableSupervision,
        setupWizard: { ...setupWizardData },
        setRulesActiveInActiveStatus: {
          ...setRulesData?.setRulesActiveInActiveStatus,
          timeSupervisionEnabled: defaultSettings.timeSupervisionEnabled,
          appMonitoringEnabled: defaultSettings.isAppMonitoringEnabled,
          webMonitoringEnabled: defaultSettings.isWebMonitoringEnabled,
          callsAndSMSMonitoringEnabled:
            defaultSettings.callsAndSMSMonitoringEnabled,
          videoMonitoringEnabled: defaultSettings.videoMonitoringEnabled,
          nudityAndImageCategorizationEnabled:
            defaultSettings.nudityMonitoringEnable,
          locationAndGeofencingEnable: defaultSettings.geoLocationEnable,
          keysrtrokesMonitoringEnabled: defaultSettings.enableKeyStroke === 1,
        },
        webmonitoring: {
          ...setRulesData?.webmonitoring,

          safeSearchYoutube: defaultSettings.safeSearchYoutube,
          enforceSafeSearchYoutube: defaultSettings.enforceSafeSearchYoutube,
          enforceSafeSearchBing: defaultSettings.enforceSafeSearchBing,
          enforceSafeSearchGoogle: defaultSettings.enforceSafeSearchGoogle,
          webMonitoringEnabled: defaultSettings.isWebMonitoringEnabled,
          safeSearch: defaultSettings.safeSearch,
          webCategory: [],
          webSupervisionType: 1,
        },
        timesupervison: {
          ...setRulesData?.timesupervison,

          kidId: kid.ID.toString(),
          deviceId: deviceId,
          loadDefaultSettings: defaultSettings.loadDefaultSettings,
          schedule: adjustDasyOfSchedule(defaultSettings.schedule),
          enableSupervision: defaultSettings.enableTimeSupervision,
          IsDeviceTimeSupervisionEnabled: defaultSettings.enableTimeSupervision,
          IsBlockWebAndAppEnabled: defaultSettings.blockWebAndAppEnabled
            ? 1
            : 0,
          dailyLimitSelectedDays: {monday: 1, tuesday: 1, wednesday: 1, thursday: 1, friday: 1, saturday: 1, sunday: 1}
        },
        appsmonitoring: {
          ...setRulesData?.appsmonitoring,

          appMonitoringEnabled: defaultSettings.appMonitoringEnabled,
          appCategory: [],
        },
        blockSettings: {
          ...setRulesData?.blockSettings,

          isSettingBlocked: defaultSettings.settingBlocked,
        },
        nudityimagecategorization: {
          ...setRulesData?.nudityimagecategorization,

          onlyNudityEnable: defaultSettings.nudityMonitoringEnable ? 1 : 0,
          detectAllNudityEnable: defaultSettings.nudityMonitoringEnable ? 1 : 0,
          deleteNudePicEnable: defaultSettings.nudityMonitoringEnable ? 1 : 0,
          screenshotNudityEnable: defaultSettings.nudityMonitoringEnable
            ? 1
            : 0,
          blockSourceNudityEnable: defaultSettings.nudityMonitoringEnable
            ? 1
            : 0,
        },
        callAndSmsMonitoring: {
          ...setRulesData?.callAndSmsMonitoring,

          callSmsActivate: defaultSettings.callsAndSMSMonitoringEnabled ? 1 : 0,
        },
        keystrokesmonitoring: {
          ...setRulesData?.keystrokesmonitoring,

          keystrokesdata: {
            activate: defaultSettings.enableKeyStroke || 1,
            activateNotification:
              defaultSettings.activateKeyStoreNotification || 0,
            activateScreenshot: defaultSettings.activateKeyStoreScreenshot || 0,
          },
        },
        videomonitoring: {
          ...setRulesData?.videomonitoring,
          videoMonitoringEnabled: defaultSettings.videoMonitoringEnabled,
        },
        locationgeofendingsettings: {
          geoLocationEnable: defaultSettings.geoLocationEnable,
        },
      };

      // Convert webCategory and appCategory logic to key-value pairs
      if (
        keyValuePairs.webmonitoring.webCategory &&
        keyValuePairs.webmonitoring.webCategory.length > 0
      ) {
        const webCategoryIds = Array.from(
          new Set(
            keyValuePairs.webmonitoring.webCategory.map((item) => item.id)
          )
        );
        keyValuePairs.webmonitoring.webCategory = webCategoryIds;
      } else {
        keyValuePairs.webmonitoring.webCategory = defaultSettings.webCategory;
      }

      if (
        keyValuePairs.appsmonitoring.appCategory &&
        keyValuePairs.appsmonitoring.appCategory.length > 0
      ) {
        const appCategoryIds = Array.from(
          new Set(
            keyValuePairs.appsmonitoring.appCategory.map((item) => item.id)
          )
        );
        keyValuePairs.appsmonitoring.appCategory = appCategoryIds;
      } else {
        keyValuePairs.appsmonitoring.appCategory = defaultSettings.appCategory;
      }

      collectionPayload = {
        ...setRulesData,
        ...keyValuePairs,
      };
    }

    if (
      !setupWizardData ||
      (!setupWizardData?.allowAllAndMonitorOnly &&
        !setupWizardData?.enableDefaultSettings &&
        !setupWizardData?.customSettings)
    ) {
      dispatch(
        setErrorInfo({
          errorInfo: true,
          title: "SETUP_WIZARD_ENABLE_ONE_OF_THEM_SETUP_WIZARD_RULE",
          defaultTitle: "Please enable one of them Setup-wizard rule.",
        })
      );
      return;
    }
    setLoader(true);
    callServiceFirebaseAndDB(collectionPayload);
  }

  function handleClickMove(redirectTo) {
    if (redirectTo === "KEYSTROKES_MONITOR") {
      history.push("/set-rules");
      dispatch(setActiveTab("SETRULE_KEYSTROKES_MONITORING"));
    } else if (redirectTo === "LOCATION") {
      history.push("/set-rules");
      dispatch(setActiveTab("SETRULE_LOCATION_AND_GEOFENCING_SETTINGS"));
    } else if (redirectTo === "SCREENSHOTS") {
      history.push("/set-rules");
      dispatch(setActiveTab("SETRULE_SCREENSHOTS"));
    }
  }


  useEffect(() => {
    if (kid) {
      kidDevices(kid?.ID)
        .then((res) => {
          dispatch(setKidDevicesList(res?.data?.result));
        })
        .catch((err) => {
          console.log(
            "getting devices list catch error ==>>",
            err?.response?.data?.message
          );
        })
        .finally(() => { });
    }
  }, [kid]);

  useEffect(() => {
    getDefaultSettingData()
      .then((res) => {
        return res;
      })
      .then((defaultData) => {
        // To fetching admin 
        const tempDefaultData = { ...defaultData };
        getDefaultSettingData("WebCategories")
          .then((webCatRes) => {
            tempDefaultData.webCategory = [...webCatRes?.categories];
          })
        getDefaultSettingData("AppCategories")
          .then((appCatRes) => {
            tempDefaultData.appCategory = [...appCatRes?.categories];
          })
        setDefaultSetting(tempDefaultData);
      })
      .catch((error) => {
        console.log("error get default setting data ==>>", error?.response?.data?.message)
      });

  }, []);

  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );

  function isSetupWizardCompleted() {
    const selectedDeviceData = kidDevicesList?.find((item) => item?.ID === deviceId);
    if (selectedDeviceData?.isSetupWizardComplete === 1) {
      return true;
    }
    return false;
  }

  return (
    <>
      <div className="card mb-6">
        <div className="card-body">
          <div className="inline-list-wrap separator space-24">
            <div className="list-item">
              <KidImage imageUrl={kid?.image} gender={kid?.gender} />
              <div className="list-content">
                <span className="text-blue-900">{kid?.childName}</span>
                <CommonStatus status={deviceStatus} />
              </div>
            </div>
            <div className="list-item flex-wrap">
              <label className="text-small text-uppercase w-100 mb-2">
                {getLangTranslation("CONNECT_DEVICE_TITLE_2", "device")}
              </label>
              <div className="d-flex justify-content-between flex-wrap flex-md-nowrap gap-3 col-md-12">
                <div className="select-with-icon">
                  <span className="icon-wrap icon-blue pt-cursor border-0">
                    <i className="icon-mobile fs-5" />
                  </span>
                  <Select
                    className="custom-select custom-select-right"
                    classNamePrefix="custom-select"
                    placeholder="Select Device"
                    options={deviceOptions}
                    onChange={(e) => setDeviceId(e.value)}
                    isSearchable={false}
                  />
                </div>

                <span className="d-inline-flex align-items-center gap-2 select-custom-text">
                  {!batteryPercentage ? 0 : batteryPercentage}%
                  <i className="icon-battery-charging fs-5" />
                </span>
              </div>
            </div>
            {!isSetupWizardCompleted() && (
              <>
                <button
                  className={`btn btn-outline-primary align-self-center ${
                    lang?.isRTL === 1 ? "me-auto" : "ms-auto"
                  }`}
                  onClick={() => history.push("/dashboard")}
                >
                  <span className="btn-upper-case">
                    {getLangTranslation(
                      "SETUP_WIZARD_BUTTON_DO_IT_LATER",
                      "DO IT LATER"
                    )}
                  </span>
                </button>
                <button
                  className="btn btn-primary align-self-center"
                  onClick={() => handleClick()}
                  disabled={loader}
                >
                  <span className="btn-upper-case">
                    {getLangTranslation("SAVE", "Save")}
                  </span>
                </button>
              </>
            )}
          </div>
        </div>
      </div>
      {!deviceId && (
        <div className="card">
          <div className="text-center my-4">
            ---{" "}
            {getLangTranslation(
              "PLS_SELECT_DEVICE_ERR_MSG",
              "Please select device"
            )}{" "}
            ---
          </div>
        </div>
      )}
      {deviceId && !isSetupWizardCompleted() && setupWizardData && (
        <div className="card">
          <div className="card-body">
            <div className="form-check form-switch mb-5">
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id="ALLOW_MONITOR"
                name="ALLOW_MONITOR"
                checked={setupWizardData?.allowAllAndMonitorOnly ?? false}
                onChange={handleToggleChange}
              />
              <label className="form-check-label" htmlFor="ALLOW_MONITOR">
                <h6>
                  {getLangTranslation(
                    "SETUP_WIZARD_ALLOW_ALL",
                    "Allow all and monitor only"
                  )}
                </h6>
                <span className="text-small">
                  {getLangTranslation(
                    "SETUP_WIZARD_ALLOW_ALL_DESC",
                    "This option will enable supervision on child device, but it will allow him to do everything without restriction and parent will get reports on all the activities."
                  )}
                </span>
              </label>
            </div>
            {setupWizardData?.allowAllAndMonitorOnly && (
              <ul className="list-blue-dots">
                <li>
                  {getLangTranslation(
                    "SETUP_WIZARD_WEB_FILTERING",
                    "Web filtering"
                  )}
                </li>
                <li>
                  {getLangTranslation(
                    "APP_MONITORING_TITLE",
                    "Apps Monitoring"
                  )}
                </li>
                <li>
                  {getLangTranslation(
                    "SETUP_WIZARD_VIDEO_MONITORING",
                    "YouTube monitoring"
                  )}
                </li>
                <li>
                  {getLangTranslation(
                    "SETUP_WIZARD_CALL_AND_SMS_MONITORING",
                    "Calls & SMS monitoring"
                  )}
                </li>
                <li>{getLangTranslation("SETUP_WIZARD_NUDITY", "Nudity")}</li>
                <li>
                  {getLangTranslation(
                    "SETUP_WIZARD_KEYSTROKE_MONITORING",
                    "Keysrtrokes monitoring"
                  )}
                  <p className="text-small my-2 text-gray">
                    {getLangTranslation(
                      "SETUP_WIZARD_KEYSTROKE_MONITORING_DESC",
                      "You need to set keywords if you want to be alerted once child type any desired keyword"
                    )}
                    .
                  </p>
                  <span
                    className="text-blue-400 text-small text-decoration-underline c-pointer"
                    onClick={() => handleClickMove("KEYSTROKES_MONITOR")}
                  >
                    {getLangTranslation(
                      "SETUP_WIZARD_KEYSTROKE_MONITORING_DO_IT_NOW",
                      "Do You Want To Do It Now?"
                    )}
                  </span>
                  {/* <Link to="/" className="text-blue-400 text-small text-decoration-underline">Do You Want To Do It Now?</Link> */}
                </li>
                <li>
                  {getLangTranslation(
                    "SETUP_WIZARD_LOCATION_SETTING",
                    "Location & geofencing settings"
                  )}
                  <p className="text-small my-2 text-gray">
                    {getLangTranslation(
                      "SETUP_WIZARD_LOCATION_SETTING_DESC",
                      "You need to set safe zones if you want to be alerted once child enter or leave any desired zone"
                    )}
                    .
                  </p>
                  <span
                    className="text-blue-400 text-small text-decoration-underline c-pointer"
                    onClick={() => handleClickMove("LOCATION")}
                  >
                    {getLangTranslation(
                      "SETUP_WIZARD_ENABLE_DEFAULT_LOCATION_DO_IT_NOW",
                      "Do You Want To Do It Now?"
                    )}
                  </span>
                </li>
                <li>
                  {getLangTranslation(
                    "SETUP_WIZARD_SCREENSHOTS",
                    "Screenshots"
                  )}
                  <p className="text-small my-2 text-gray">
                    {getLangTranslation(
                      "SETUP_WIZARD_SCREENSHOTS_DESC",
                      "You need to set apps to be monitored by screenshots"
                    )}
                  </p>{" "}
                  <Link
                    to="/screen-shot-select-apps"
                    className="text-blue-400 text-small text-decoration-underline"
                  >
                    {getLangTranslation(
                      "SETUP_WIZARD_SCREENSHOTS_DO_IT_NOW",
                      "Do You Want To Do It Now?"
                    )}
                  </Link>
                </li>
              </ul>
            )}

            <hr className="my-6" />
            <div className="form-check form-switch mb-5">
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id="ENABLE_DEFAULT_SETTINGS"
                name="ENABLE_DEFAULT_SETTINGS"
                checked={setupWizardData?.enableDefaultSettings ?? false}
                onChange={handleToggleChange}
              />
              <label
                className="form-check-label"
                htmlFor="ENABLE_DEFAULT_SETTINGS"
              >
                <h6>
                  {getLangTranslation(
                    "SETUP_WIZARD_ENABLE_DEFAULT_SETTING",
                    "Enable default settings"
                  )}
                </h6>
                <span className="text-small">
                  {getLangTranslation(
                    "SETUP_WIZARD_ENABLE_DEFAULT_SETTING_DESC",
                    "This option will enable the default selected settings by us, enable to see more details."
                  )}
                </span>
              </label>
            </div>
            {setupWizardData?.enableDefaultSettings && (
              <ul className="list-blue-dots">
                <li>
                  {getLangTranslation(
                    "SETUP_WIZARD_KEYSTROKE_MONITORING",
                    "Keysrtrokes monitoring"
                  )}
                  <p className="text-small my-2 text-gray">
                    {getLangTranslation(
                      "SETUP_WIZARD_KEYSTROKE_MONITORING_DESC",
                      "You need to set keywords if you want to be alerted once child type any desired keyword"
                    )}
                    .
                  </p>
                  <span
                    className="text-blue-400 text-small text-decoration-underline c-pointer"
                    onClick={() => handleClickMove("SCREENSHOTS")}
                  >
                    {getLangTranslation(
                      "SETUP_WIZARD_SCREENSHOTS_DO_IT_NOW",
                      "Do You Want To Do It Now?"
                    )}
                  </span>
                </li>
                <li>
                  {getLangTranslation(
                    "SETUP_WIZARD_ENABLE_DEFAULT_LOCATION",
                    "Location & geofencing settings"
                  )}
                  <p className="text-small mt-2 text-gray">
                    {getLangTranslation(
                      "SETUP_WIZARD_LOCATION_SETTING_DESC",
                      "You need to set safe zones if you want to be alerted once child enter or leave any desired zone"
                    )}
                  </p>
                  {/* <p>  Do You Want To Do It Now?</p> */}
                  <span
                    className="text-blue-400 text-small text-decoration-underline c-pointer"
                    onClick={() => handleClickMove("LOCATION")}
                  >
                    {getLangTranslation(
                      "SETUP_WIZARD_LOCATION_SETTING_DO_IT_NOW",
                      "Do You Want To Do It Now?"
                    )}
                  </span>
                </li>
                <li>
                  {getLangTranslation(
                    "SETUP_WIZARD_ENABLE_DEFAULT_NUDITY",
                    "Nudity monitoring enabled"
                  )}
                </li>
                <li>
                  {getLangTranslation(
                    "SETUP_WIZARD_ENABLE_DEFAULT_VIDEO",
                    "YouTube monitoring enabled"
                  )}
                </li>
                <li>
                  {getLangTranslation(
                    "SETUP_WIZARD_ENABLE_DEFAULT_CALL_AND_SMS",
                    "Call and SMS monitoring enabled"
                  )}
                </li>
                <li>
                  {getLangTranslation(
                    "SETUP_WIZARD_ENABLE_DEFAULT_DEVICE_TIME",
                    "Device time supervision enabled"
                  )}
                </li>
                <li>
                  {getLangTranslation(
                    "SETUP_WIZARD_ENABLE_DEFAULT_SAFE_SEARCH",
                    "Safe Search enabled on web and YouTube"
                  )}
                </li>
                <li>
                  {getLangTranslation(
                    "SETUP_WIZARD_ENABLE_DEFAULT_ALLOW_TIME",
                    "Allowed time (24 hours format) -"
                  )}{" "}
                  <span className="text-blue-400">
                    {getLangTranslation(
                      "SETUP_WIZARD_ENABLE_DEFAULT_ALLOW_TIME_DUMMY",
                      "08:00 - 17:00"
                    )}
                  </span>
                </li>
                <li>
                  {getLangTranslation(
                    "SETUP_WIZARD_ENABLE_DEFAULT_SETTINGS_APP_BLOCK",
                    "Settings app will be blocked"
                  )}
                </li>
                <li>
                  {getLangTranslation(
                    "SETUP_WIZARD_ENABLE_DEFAULT_FOLLOWING_WEB_CATEGORIE",
                    "The following web categories will be blocked"
                  )}
                  <ul className="text-blue-400 text-small">
                    <li className="mt-1">
                      {getLangTranslation(
                        "SETUP_WIZARD_ENABLE_DEFAULT_ADULT",
                        "ADULT"
                      )}
                    </li>
                    <li className="mt-1">
                      {getLangTranslation(
                        "SETUP_WIZARD_ENABLE_DEFAULT_SENSITIVE_SUBJECTS",
                        "SENSITIVE SUBJECTS"
                      )}
                    </li>
                    <li className="mt-1">
                      {getLangTranslation(
                        "SETUP_WIZARD_ENABLE_DEFAULT_UNCATEGORY",
                        "UNCATEGORIZED"
                      )}
                    </li>
                  </ul>
                </li>
                <li>
                  {getLangTranslation(
                    "SETUP_WIZARD_ENABLE_DEFAULT_FOLLOWING_APP_CATEGORIE",
                    "The following apps categories will be blocked"
                  )}
                  <ul className="text-blue-400 text-small">
                    <li className="mt-1">
                      {getLangTranslation(
                        "SETUP_WIZARD_ENABLE_DEFAULT_DATING",
                        "DATING"
                      )}
                    </li>
                  </ul>
                </li>
              </ul>
            )}

            <hr className="my-6" />
            <div className="form-check form-switch mb-5">
              <input
                className="form-check-input"
                type="checkbox"
                id="CUSTOM_SETTINGS"
                name="CUSTOM_SETTINGS"
                role="switch"
                checked={setupWizardData?.customSettings ?? false}
                onChange={handleToggleChange}
              />
              <label className="form-check-label" htmlFor="CUSTOM_SETTINGS">
                <h6>
                  {getLangTranslation(
                    "SETUP_WIZARD_ENABLE_DEFAULT_CUSTOM_SETTING",
                    "Custom settings"
                  )}
                </h6>
                <span className="text-small">
                  {getLangTranslation(
                    "SETUP_WIZARD_ENABLE_DEFAULT_SET_RULE_ONE_BY_ONE",
                    "This will allow you to set your own rules for each feature one by one."
                  )}
                </span>
              </label>
            </div>
          </div>
        </div>
      )}
      {deviceId && isSetupWizardCompleted() && setupWizardData && (
        <div className="card">
          <div className="text-center my-3">
            <i>
              {getLangTranslation(
                "SETUP_WIZARD_ALREADY_COMPLETED",
                "Setup wizard already completed"
              )}
            </i>
          </div>
        </div>
      )}
    </>
  );
  // }
};

export default SetupWizard;
